export const SSO_CALLBACK_PATH = "/auth/sso/callback";

export const AUTH_LOGIN_PATH = "/auth/login";
